module.exports = __webpack_public_path__ + "assets/img/2605.a45040c1.svg";